export function countdown() {
      return {
        start: function(seconds){
          let handler = {};
          let destroyed = false;
          function tick() {
            if (destroyed) {
              if (handler.onDestory) {
                handler.onDestory();
              }
              return;
            }
            if (seconds > 0) {
              if (handler.onTick) {
                handler.onTick(seconds--);
              }
              setTimeout(tick, 1000);
            } else {
              if (handler.onEnd) {
                handler.onEnd();
              }
            }
          }
          setTimeout(function () {
            if (handler.onStart) {
              handler.onStart();
            }
            tick();
          });
          handler.destory = function(){
            destroyed = true;
          };
          return handler;
        }
      }
    }